import MojitoCore from 'mojito/core';
import { isEmpty } from 'mojito/utils';
import MojitoPresentation from 'mojito/presentation';
import PrebuiltBets from 'modules/prebuilt-bets/index.jsx';
import { usePreBuiltBetCardsPromotions } from 'modules/event-cards-carousel/hooks';
import {
    usePromotions,
    usePromotionsPreload,
    usePromotionsLoadDone,
} from 'modules/promotions/hooks';
import { useLoadingStatusMetric } from 'modules/performance/hooks';
import { useMemo } from 'react';
const { useIrreversibleTrue } = MojitoPresentation.Hooks;
const { Context: AnalyticsContext, ContextBuilder: AnalyticsContextBuilder } =
    MojitoCore.Presentation.AnalyticsContext;

const PrebuiltPromotionCards = props => {
    const {
        applicablePage,
        mojitoTools: { config, instanceId },
    } = props;

    const analyticsContext = useMemo(() => {
        return new AnalyticsContextBuilder().withAnalyticsPath(applicablePage).build();
    }, [applicablePage]);

    const { locationId, reportLoadingStatus } = config;

    const cardPromotions = usePromotions(locationId, applicablePage);
    const cards = usePreBuiltBetCardsPromotions(cardPromotions);

    const promotionsLoaded = usePromotionsLoadDone([locationId]);

    const [onPrepareCardsToRender, eventsLoaded, marketsLoaded] = usePromotionsPreload(
        cardPromotions,
        promotionsLoaded,
        instanceId
    );
    const betItems = useMemo(() => {
        return cards.map(card => ({
            eventId: card.content.eventId,
            marketId: card.content.marketId,
        }));
    }, [cards]);
    const isContentLoaded = promotionsLoaded && eventsLoaded && marketsLoaded;
    const initialLoadDone = useIrreversibleTrue(isContentLoaded);

    const noContent = promotionsLoaded && isEmpty(betItems);
    const elementRef = useLoadingStatusMetric(
        initialLoadDone || noContent,
        reportLoadingStatus ? instanceId : undefined,
        'PrebuiltPromotionCards',
        noContent
    );
    if (noContent) {
        return null;
    }

    return (
        <AnalyticsContext.Provider value={analyticsContext}>
            <PrebuiltBets
                config={config.prebuiltBets}
                betItems={betItems}
                onPrepareCardsToRender={onPrepareCardsToRender}
                isContentLoaded={initialLoadDone}
                elementRef={elementRef}
            />
        </AnalyticsContext.Provider>
    );
};

export default PrebuiltPromotionCards;
